import React from 'react';
import cn from 'class-names';

import { FeeTableColumnType, FeeTableRowType } from '../../types';

import './FeeTable.scss';

type Props = {
  columns: FeeTableColumnType[];
  rows: FeeTableRowType[];
};

function FeeTable({ columns, rows }: Props): JSX.Element {
  return (
    <div className="fee-table">
      <table className="fee-table__table">
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.title} className="fee-table__head-cell">
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.cells[0]} className="fee-table__row">
              {row.cells.map((cell, cellIndex) => (
                <td
                  key={columns[cellIndex].title}
                  className={cn('fee-table__cell', {
                    'fee-table__cell--fee': columns[cellIndex].isFee,
                    'fee-table__cell--first': cellIndex === 0,
                  })}
                >
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FeeTable;
